
import React from 'react';

const ToolbarSeparator = () => {

    return (
        <div style={{width: 16, height: 16}} />
    );
}

export default ToolbarSeparator;
